import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import BreadCrumbs from "../../../../components/Breadcrumbs";
import { TableSkeleton } from "../../../../components/Skeleton";
import HelpButton from "../../../core/components/HelpDialog/HelpButton";

function Layout() {
  const user = useSelector((state) => state.auth.userData);
  const customStyle = user ? { m: "0 0.625rem", p: "0.625rem" } : {};
  return (
    <Box
      tabIndex="-1"
      id="bodyContainer"
      sx={{ ...customStyle, position: "relative" }}
    >
      {user && !user.addNewUser && <BreadCrumbs />}
      {!user && <HelpButton />}
      <Suspense fallback={<TableSkeleton />}>
        <Outlet />
      </Suspense>
    </Box>
  );
}

export default Layout;
